import { userActions } from "../reducers/userReducer";

export const logout = () => (dispatch) => {
  console.log("logout");
  dispatch(userActions.resetUserInfo());
  localStorage.removeItem("account");
};
